module.exports = __webpack_public_path__ + "static/media/demon-female.2d13e25b.png";